<div class="flex-row-container m-t5">
  <span class="flex-1 m-t10 m-l15 blueText16 B">Incomes</span>
  <button mat-stroked-button class="m-r10" color="primary" [ngClass]="isDataChanged?'highlight-bg':''" (click)="saveSelectedIncomes()">Save</button>
  <!-- <button class="m-r10 font14" mat-stroked-button color="primary">Add Income</button> -->
  <button [matMenuTriggerFor]="incomemenu" class="m-r10 font14" mat-stroked-button color="primary" (click)="$event.stopPropagation();">Add Income</button>
</div>
<div class="flex-row-center m-t8">
  <mat-divider class="divider" style="width: 99%"></mat-divider>
</div>
<div class="summary-panel-container" (click)="$event.stopPropagation();">
  <mat-card *ngFor="let inc of incomes" class="summary-item pointer" [matBadge]="inc.isIncluded?'check':''" [style.background]="inc.isIncluded?'#D5D7F2':''" (click)="selectIncome(inc.incId)">
    <mat-card-content> 
      <div class="flex-col-container">
        <span class="blueText20 text-truncate">{{inc.incDesc}}</span>        
      </div>
        <div class="flex-row-container m-t3">
          <div class="flex-col-container wd-60">
            <span class="font14">({{inc.incTypeDesc}})</span>            
            <span class="font15">{{inc.start}} - {{inc.end}}</span>  
            <span class="font18 text-truncate">{{inc.ownerName}}</span>
            <!-- <span class="font15 text-truncate">Annual Inflation: {{inc.growthType==='INF'?'Inflation 2.0': inc.growthRate}}%</span> -->
          </div>
          <div class="flex-col-end m-l25 wd-40">            
            <span class="blueText22">{{inc.amount | currency:'USD': 'symbol' : '1.0-0'}}</span>
            <span class="font14 gray-text" style="margin-top: -5px">per {{inc.isMonthly?'month':'year'}}</span>            
            <div class="flex-row-container">
              <mat-icon class="font20 m-l10 pointer" (click)="editIncome(inc.incId);$event.stopPropagation();">edit</mat-icon>                            
              <mat-icon class="font20 m-l10 pointer" (click)="deleteIncome(inc.incId, inc.incDesc);$event.stopPropagation();">delete</mat-icon>                            
            </div>            
          </div>                    
        </div>        
    </mat-card-content>
  </mat-card>
</div>

<mat-menu #incomemenu="matMenu">
  
  <div class="" *ngFor="let item of incomeTypeMenuItems">
    <button *ngIf="item.type!=='Joint'" class="font14" mat-menu-item [matMenuTriggerFor]="sub_menu"> {{item.displayClientname}}</button>
    <button *ngIf="item.type==='Joint'" class="font14" mat-menu-item (click)="addIncome('OT', '0');$event.stopPropagation();"> {{item.displayClientname}}</button>
    <mat-menu #sub_menu="matMenu">
         <button *ngFor="let subItem of item.subMenuItems"  class="font14" mat-menu-item (click)="addIncome(subItem.code, subItem.clientid);$event.stopPropagation();" >{{ subItem.value }}</button>
    </mat-menu>
  </div> 

</mat-menu>